/* eslint-disable no-shadow */
import {
  fetchProviderInfo,
  saveProviderInfo,
} from './provider-business.service';

const state = {
  provider: {
    id: undefined,
    provider_name: '',
    tin: '',
    tin_type: '',
    address: '',
    phone_number: '',
    phone_number_formatted: '',
    first_name: '',
    last_name: '',
    email: '',
    bank_account: {},
    accept_kinside_payment: false,
    payment_acceptance_method: '',
    company_name: '',
    website: '',
    provider_type: '',
    full_address: '',
    card: {} || undefined,
    bank_account_moov_status: '',
    moov_status_message: '',
  },
};

const getters = {
  providerBusinessInfo: (state) => state.provider,
};

const mutations = {
  setProviderBusinessInfo: (state, provider) => {
    state.provider = provider;
  },
};

const actions = {
  async fetchProviderBusinessInfo({ commit, dispatch }, id) {
    if (!id) {
      dispatch('notifications/addToastError', { text: 'Could not fetch provider business info' }, { root: true });
      return;
    }

    try {
      const businessInfo = await fetchProviderInfo(id);
      commit('setProviderBusinessInfo', businessInfo);
    } catch (error) {
      dispatch('notifications/addToastError', { text: 'Could not fetch provider business info', error }, { root: true });
    }
  },

  async saveProviderBusinessInfo({ dispatch }, providerData) {
    try {
      await saveProviderInfo(providerData);
    } catch (error) {
      dispatch('notifications/addToastError', { text: 'Could not save provider business info', error }, { root: true });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
